import { Injectable } from '@angular/core';

@Injectable()
export class NotificationService {
  private _notification: Notification = null;
  constructor() {}

  get notification() {
    return this._notification;
  }

  push(title: string, options?: NotificationOptions) {
    // navigator.serviceWorker.getRegistration().then((reg) => {
    //   reg.pushManager.subscribe
    //   this.notify(title, options);
    // })
    if (!Notification) {
      // æç¤ºä¸æ¯æç³»ç»éç¥
      alert('æ¨çæµè§å¨ä¸æ¯æç³»ç»éç¥,å»ºè®®ä½¿ç¨Chromeæµè§');
    }
    // è¡¨ç¤ºä¹ååç¨æ·è¯·æ±è¿æéï¼èä¸ç¨æ·å·²ç»åè®¸äºã
    const PERMISSON_GRANTED = 'granted';
    // è¡¨ç¤ºä¹ååç¨æ·è¯·æ±è¿æéï¼ä½æ¯ç¨æ·å·²ç»æç»äºã
    const PERMISSON_DENIED = 'denied';
    // è¿æ²¡æååºè¿è¯·æ±ï¼æèä¹åè¯·æ±è¿ï¼ä½æ¯ç¨æ·å¹¶æ²¡æåè®¸æèç¦æ­¢ï¼äºæ¯ç´æ¥å³é­çªå£ãè¿ç§ç¶æä¸æ¯ä¸ä¼æéç¥çã
    const PERMISSON_DEFAULT = 'default';
    if (Notification.permission === PERMISSON_GRANTED) {
      this.notify(title, options);
    } else {
      // ç¨æ·æç»äºéç¥æé
      console.log('Permission for Notifications was denied');
      Notification.requestPermission().then((res) => {
        if (res === PERMISSON_GRANTED) {
          this.notify(title, options);
        }
      });
    }
  }

  close() {
    if (this._notification) {
      this._notification.close();
    }
  }

  /**
   *
   *
   * @private
   * @param {string} title
   * @param {NotificationOptions} [options] éè¿æµè§å¨æµè¯å(Firefoxå«MacåWindowsãChromeå«MacåWindowsãSafari)ï¼éç¨çææéç½®ä»æ3ä¸ªï¼titleï¼bodyï¼icon
   * @memberof NotificationService
   */
  private notify(title: string, options?: NotificationOptions) {
    this._notification = new Notification(title, options);
    this._notification.onshow = function(event) {
      // çªå£æ¾ç¤º æ­æ¾é³é¢
      // var audio = new Audio('./10418.wav');
      // audio.play();
    };
    this._notification.onclose = function(event) {
      // console.log('close : ', event);
    };
    this._notification.onclick = function(event) {
      //å¦æéç¥æ¶æ¯è¢«ç¹å»,éç¥çªå£å°è¢«æ¿æ´»
      window.focus();
      this.close();
    };
  }
}
